import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowUpRightIcon, MenuIcon, XIcon } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
const navLinks = [{
  name: 'Servicios',
  href: '/servicios'
}, {
  name: 'Proceso',
  href: '/proceso'
}, {
  name: 'Enfoque',
  href: '/resultados'
}, {
  name: 'FAQ',
  href: '/faq'
}, {
  name: 'Contacto',
  href: '/contacto'
}];
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 16);
    handleScroll();
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);
  useEffect(() => {
    document.body.style.overflow = isMobileMenuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMobileMenuOpen]);
  return <>
    <header className={`fixed inset-x-0 top-0 z-[70] border-b border-white/10 bg-black/95 backdrop-blur-md transition-[padding] duration-200 ${isScrolled ? 'py-3' : 'py-4'}`} data-id="element-64" data-mp="jm3zk9hhpdc0">
      <div className="container mx-auto flex items-center justify-between gap-6 px-6 md:px-12" data-id="element-65" data-mp="3n3ma4ooncyg4">
        <Link to="/" className="relative z-50 inline-flex items-center text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-black" aria-label="Growthly, inicio" data-id="element-66" data-mp="3s279ymzzlg41">
          <span className="text-[13px] font-semibold tracking-[0.16em]" data-id="element-67" data-mp="5opax6z299l3">
            GROWTHLY
          </span>
        </Link>

        <nav className="hidden items-center lg:flex" aria-label="Navegación principal" data-id="element-68" data-mp="39bfssz9rclf3">
          <ul className="flex items-center gap-1" data-id="element-69" data-mp="31a85d94d0f1s">
            {navLinks.map(link => {
              const isActive = location.pathname === link.href;
              return <li key={link.href} data-id="element-70" data-mp="3b1mco32jyj5h">
                  <Link to={link.href} aria-current={isActive ? 'page' : undefined} className={`relative block px-3.5 py-2 text-[13px] font-medium tracking-[0.01em] transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-white ${isActive ? 'text-white' : 'text-neutral-300 hover:text-white'}`} data-id="element-71" data-mp="3b0jlrv58cgpk">
                    {link.name}
                    {isActive && <motion.span layoutId="nav-indicator" className="absolute inset-x-3.5 -bottom-0.5 h-px bg-white" transition={{
                    type: 'spring',
                    stiffness: 450,
                    damping: 38
                  }} data-id="element-72" data-mp="2naz1n8xcbdep" />}
                  </Link>
                </li>;
            })}
          </ul>
          <Link to="/checkout" className="ml-5 inline-flex items-center gap-2 bg-white px-4 py-2.5 text-[13px] font-semibold text-black transition-colors hover:bg-neutral-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-black" data-id="element-73" data-mp="14drimrc360l">
            Empezar <ArrowUpRightIcon size={14} aria-hidden="true" data-id="element-74" data-mp="xtv47loqhsbs" />
          </Link>
        </nav>

        <button type="button" className="relative z-50 inline-flex h-10 w-10 items-center justify-center border border-white/20 text-white transition-colors hover:border-white/50 lg:hidden focus:outline-none focus-visible:ring-2 focus-visible:ring-white" onClick={() => setIsMobileMenuOpen(isOpen => !isOpen)} aria-label={isMobileMenuOpen ? 'Cerrar menú' : 'Abrir menú'} aria-expanded={isMobileMenuOpen} data-id="element-75" data-mp="k26shjied5vc">
          {isMobileMenuOpen ? <XIcon size={19} data-id="element-76" data-mp="3k1svjcdqhrid" /> : <MenuIcon size={19} data-id="element-77" data-mp="3k19d7uk6913t" />}
        </button>
      </div>
    </header>

    {/*
      El panel móvil vive FUERA del <header>: el header usa backdrop-blur, que
      crea un bloque contenedor para los hijos position:fixed y recortaba el
      menú a la altura de la barra.
     */}
      <AnimatePresence data-id="element-78" data-mp="blzemwfhqe0s">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.18,
        ease: 'easeOut'
      }} className="fixed inset-0 z-[60] h-[100dvh] max-h-[100dvh] overflow-y-auto overscroll-contain bg-black px-6 pt-24 lg:hidden" style={{
        paddingBottom: 'calc(3rem + env(safe-area-inset-bottom))'
      }} data-id="element-79" data-mp="6nxtm5yi84mo">
            <nav aria-label="Navegación móvil" data-id="element-80" data-mp="28behkxn1hntz">
              <ul className="border-t border-white/10" data-id="element-81" data-mp="2d84whhn3yddt">
                {[{
              name: 'Inicio',
              href: '/'
            }, ...navLinks].map(link => {
              const isActive = location.pathname === link.href;
              return <li key={link.href} className="border-b border-white/10" data-id="element-82" data-mp="2r85w6trmzerp">
                      <Link to={link.href} onClick={() => setIsMobileMenuOpen(false)} aria-current={isActive ? 'page' : undefined} className={`flex items-center justify-between py-4 text-xl font-medium tracking-tight focus:outline-none focus-visible:ring-2 focus-visible:ring-white ${isActive ? 'text-white' : 'text-neutral-300'}`} data-id="element-83" data-mp="2w67m9ynhceco">
                        {link.name}
                        <ArrowUpRightIcon size={18} aria-hidden="true" className={isActive ? 'text-white' : 'text-neutral-500'} data-id="element-84" data-mp="1ewsiafg6wtlt" />
                      </Link>
                    </li>;
            })}
              </ul>
            </nav>
            <Link to="/checkout" onClick={() => setIsMobileMenuOpen(false)} className="mt-8 flex items-center justify-center gap-2 bg-white px-5 py-4 text-sm font-semibold text-black focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-black" data-id="element-85" data-mp="1xm8ljaj9f05x">
              Iniciar mi proyecto{' '}
              <ArrowUpRightIcon size={16} aria-hidden="true" data-id="element-86" data-mp="d6dkow6eaz5f" />
            </Link>
            <p className="mt-4 text-center text-xs text-neutral-400" data-id="element-87" data-mp="d88aansm3ffu">
              Oferta única · 350 € (EUR) · Sin cuotas
            </p>
          </motion.div>}
      </AnimatePresence>
    </>;
}